<template>
    <v-container>
      <v-card class="mx-auto" flat>
        <v-card-title style="color: #B08836" class="font-weight-bold">
          <h2 class="heading font-weight-bold">Estadística Promociones</h2>
          <v-spacer></v-spacer>
          <v-btn class="mr-2" color="#0A4A79" dark to="/panel" small>
            <v-icon small class="mr-2">mdi-arrow-left</v-icon>
            Ir a Panel
          </v-btn>
          <v-btn color="#0A4A79" dark to="/reporte/promociones" small>
            <v-icon small class="mr-2">mdi-file</v-icon>
            Ir a Reporte Detallado
          </v-btn>
        </v-card-title>
        <v-divider class="mb-5"></v-divider>

        <!-- Tarjeta integrada con filtros, período y tabla -->
        <v-card class="mx-auto elevation-2" outlined style="max-width: 920px; border-radius: 8px; overflow: hidden; border-color: #E0E0E0;">
          <!-- Sección de Filtros -->
          <div class="pa-4" style="background-color: #F8FAFC;">
            <v-row align="center">
              <v-col cols="12" sm="5" class="py-2">
                <v-menu
                  ref="dialogFecInicio"
                  v-model="dialogFecInicio"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fecha_inicio"
                      label="Fecha Inicial"
                      prepend-inner-icon="mdi-calendar-outline"
                      readonly
                      v-on="on"
                      dense
                      clearable
                      outlined
                      hide-details
                      background-color="white"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fecha_inicio"
                    @input="dialogFecInicio = false"
                    locale="es-mx"
                    min="2010-01-01"
                    :max="new Date().toISOString().substr(0, 10)"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="5" class="py-2">
                <v-menu
                  ref="dialogFecFin"
                  v-model="dialogFecFin"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fecha_fin"
                      label="Fecha Final"
                      prepend-inner-icon="mdi-calendar-outline"
                      readonly
                      v-on="on"
                      dense
                      outlined
                      clearable
                      hide-details
                      background-color="white"
                      :disabled="disabledFechaFin"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fecha_fin"
                    @input="dialogFecFin = false"
                    locale="es-mx"
                    :min="fecha_inicio"
                    :max="new Date().toISOString().substr(0, 10)"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="2" class="py-2">
                <v-btn
                  class="white--text"
                  block
                  color="#0A4A79"
                  height="40"
                  :loading="loading"
                  @click="getPromocionesSalas()"
                >
                  <v-icon class="mr-2" small>mdi-magnify</v-icon>
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <v-divider></v-divider>

          <!-- Título del Período de la Tabla -->
          <div class="periodo-header py-3 px-4 d-flex align-center justify-center text-center">
            <v-icon color="#B08836" class="mr-2" size="22">mdi-calendar-month</v-icon>
            <span class="periodo-title">
              {{ tituloPeriodo }}
            </span>
          </div>

          <v-divider></v-divider>

          <!-- Tabla de Resultados Integrada -->
          <v-data-table
            :headers="headers"
            :items="listData"
            :items-per-page="20"
            :loading="loading"
            class="tabla-estadistica elevation-0"
            hide-default-footer
            disable-pagination
            no-data-text="No se Encontraron Registros"
          >
            <template v-slot:item.promociones_count="{ item }">
              <div class="text-left font-weight-medium">{{ item.promociones_count }}</div>
            </template>
            <template v-slot:item.no_contestadas="{ item }">
              <div class="text-left">{{ item.no_contestadas }}</div>
            </template>
            <template v-slot:item.promociones_contestadas="{ item }">
              <div class="text-left">{{ item.promociones_contestadas }}</div>
            </template>
            <template slot="body.append">
              <tr class="totales-row">
                <th class="totales-cell text-left font-weight-bold">Totales</th>
                <th class="totales-cell text-left font-weight-bold">{{ sumField('promociones_contestadas') }}</th>
                <th class="totales-cell text-left font-weight-bold">{{ sumField('no_contestadas') }}</th>
                <th class="totales-cell text-left font-weight-bold">{{ sumField('promociones_count') }}</th>
              </tr>
            </template>
          </v-data-table>
        </v-card>

        <v-row justify="space-around">
          <v-col cols="auto">
           <v-dialog
             v-model="dialog"
             persistent
             max-width="70%"
           >
             <template>
               <v-card>
                 <v-form @submit.prevent="saveJuez" ref="form" v-model="valid" lazy-validation>
                 <v-toolbar
                   color="grey darken-2"
                   dense
                   dark
                 >Promociones
                 <v-spacer></v-spacer>
                   <v-btn
                     dark
                     text
                     @click="close()"
                   >
                     Cerrar
                     <v-icon>mdi-close</v-icon>
                   </v-btn>
               </v-toolbar>

                <v-data-table
                  align="left"
                  :loading="loadingTable"
                  :headers="headersSala"
                  :items="listHistorial"
                  item-key="id"
                  :page.sync="page"
                  :items-per-page="per_page_table"
                  hide-default-footer
                  no-data-text="No se Encontraron Registros"
                  @page-count="pageCount = $event"
                >
                <template v-slot:item.status="{ item }">
                  <td v-if="item.status == 2" >Registrada</td>
                  <td v-if="item.status == 3" >Contestada</td>
                </template>

                <template v-slot:item.area="{ item }" >
                  <td><span>Sala {{item.sala_id}}</span></td>
                </template>

                <template  v-slot:item.fechas="{ item }" >
                  <td>
                    <span v-if="item.fecha_contestacion">Contestación: {{item.fecha_contestacion | formatDate}}</span>
                    <br v-if="item.fecha_contestacion">
                    <span>Registrada: {{item.created_at | formatDate}} {{ }}</span>
                  </td>
                </template>

                <template v-slot:item.acciones="{ item }">
                  <v-btn class=""  dark x-small color="green" @click="showPromocion(item)">
                    <v-icon small dark left>mdi-file</v-icon>
                    Ver promoción
                  </v-btn>
                </template>

              </v-data-table>
              <div class="text-center pt-2">
                <v-pagination
                  v-if="pagination.total > 1"
                  v-model="pagination.current"
                  :length="pagination.total"
                  :total-visible="7"
                  @input="onPageChange"
                  color="blue"
                  circle
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                ></v-pagination>
              </div>
              </v-form>
               </v-card>
             </template>
           </v-dialog>
         </v-col>
       </v-row>

      </v-card>

</v-container>

</template>

<script>
import { mapGetters } from 'vuex';

  export default {
    data () {
      return {
        dialog: false,
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        per_page_table: 1,
        valid: true,
        loading: false,
        loadingTable: false,
        listHistorial: [],
        sala_id: '',
        dialogFecInicio: false,
        dialogFecFin: false,
        disabledFechaFin: true,
        fecha_inicio: '',
        fecha_fin: '',
        fecha_inicio_consultada: '',
        fecha_fin_consultada: '',
        pagination: {
          current: 1,
          total: 0
        },
        headersSala: [
          { text: 'Toca', value: 'numero_completo' },
          { text: 'Área', value: 'area' },
          { text: 'Estatus', value: 'status', sortable: false },
          { text: 'Registro de fechas', value: 'fechas' },
          { text: 'Acciones', value: 'acciones', sortable: false }
        ],
        headers: [
          {
            text: 'Sala',
            align: 'start',
            sortable: false,
            value: 'nombre',
            class: "grey-text"
          },
          { text: 'Contestadas', value: 'promociones_contestadas',class: "grey-text", sortable: false, },
          { text: 'No Contestadas', value: 'no_contestadas',class: "grey-text", sortable: false, },
          { text: 'Total', value: 'promociones_count',class: "grey-text", sortable: false, },
          // { text: 'Total de Promociones', value: 'total',class: "grey-text", sortable: false, },
          // { text: 'Acciones', value: 'action', sortable: false }
        ],
      }
    },
    computed:{
      ...mapGetters([
        "listPromocionesTotal"
      ]),
      listData: function () {
        if (!this.listPromocionesTotal) return [];
        return this.listPromocionesTotal.filter(function (sala) {
          return sala.id <= 11
        })
      },
      tituloPeriodo: function () {
        if (this.fecha_inicio_consultada && this.fecha_fin_consultada) {
          const fInicio = this.formatFechaObj(this.fecha_inicio_consultada);
          const fFin = this.formatFechaObj(this.fecha_fin_consultada);

          if (this.fecha_inicio_consultada === this.fecha_fin_consultada) {
            return `Período correspondiente al día ${fInicio.dia} de ${fInicio.mes} del año ${fInicio.anio}`;
          }

          if (fInicio.anio === fFin.anio) {
            return `Período comprendido del día ${fInicio.dia} de ${fInicio.mes} al ${fFin.dia} de ${fFin.mes} del año ${fFin.anio}`;
          } else {
            return `Período comprendido del día ${fInicio.dia} de ${fInicio.mes} del año ${fInicio.anio} al ${fFin.dia} de ${fFin.mes} del año ${fFin.anio}`;
          }
        } else if (this.fecha_inicio_consultada) {
          const fInicio = this.formatFechaObj(this.fecha_inicio_consultada);
          return `Período a partir del día ${fInicio.dia} de ${fInicio.mes} del año ${fInicio.anio}`;
        } else if (this.fecha_fin_consultada) {
          const fFin = this.formatFechaObj(this.fecha_fin_consultada);
          return `Período hasta el día ${fFin.dia} de ${fFin.mes} del año ${fFin.anio}`;
        }

        return 'Período: Histórico General';
      }
    },
    watch: {
      fecha_inicio: function (val) {
        this.disabledFechaFin = false;
        if (!val) {
          this.disabledFechaFin = true;
          this.fecha_fin = '';
        }
      },
    },
    mounted(){
      this.getPromocionesSalas();
    },
    methods:{
      formatFechaObj(fechaStr) {
        if (!fechaStr) return { dia: '', mes: '', anio: '' };
        const partes = fechaStr.split('-');
        if (partes.length !== 3) return { dia: '', mes: '', anio: '' };
        const anio = partes[0];
        const mesIndex = parseInt(partes[1], 10) - 1;
        const dia = parseInt(partes[2], 10);
        const meses = [
          'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
          'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ];
        return {
          dia: dia,
          mes: meses[mesIndex] || '',
          anio: anio
        };
      },
      sumField(key) {
          // sum data in give key (property)
          return this.listData.reduce((a, b) => a + (Number(b[key]) || 0), 0)
      },
      getPromocionesSalas() {
        this.loading = true;
        this.fecha_inicio_consultada = this.fecha_inicio;
        this.fecha_fin_consultada = this.fecha_fin;
        this.$store.dispatch("GET_PROMOCIONES_SALAS", {
          url: "/multifirma/estadisticas",
          params: {
            fecha_ini: this.fecha_inicio,
            fecha_fin: this.fecha_fin
          }
        })
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
      },
      onPageChange() {
        this.getPromociones();
      },
      getPromociones(item) {
        if (item) {
          this.sala_id = item.id
        }
        // this.sala_id = item.id
        this.dialog = true
        this.loadingTable = true
        this.$store.dispatch("GET_PROMOCIONES", {
            url:"/promociones?page="+this.pagination.current,
            params: {
              status: this.status,
              sala_id: this.sala_id,
              fecha_ini: this.fecha_inicio_consultada,
              fecha_fin: this.fecha_fin_consultada
            }
          })
          .then((response) => {
            //console.log(response.data);
            this.loadingTable = false
            this.pagination.current = response.data.data.promociones.current_page;
            this.pagination.total = response.data.data.promociones.last_page;
            this.per_page_table = response.data.data.promociones.per_page;
            this.listHistorial = response.data.data.promociones.data;
          })
          .catch(err => {
            this.loadingTable = false;
            console.log(err);
          });
      },
      showPromocion(item){
        this.$store.dispatch("SHOW_PROMOCION", {
          url:"/promocion/"+ item.id,
        } )
        .then((response) => {
        this.$router.push('/escritos/show' )
        })
        .catch(err => {
          console.log(err);
        });
      },
      close() {
        this.dialog = false
        this.pagination.current = 1
      },
    }

  }
</script>

<style scoped>
.periodo-header {
  background-color: #F4F7FA;
}

.periodo-title {
  color: #0A4A79;
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0.2px;
}

.totales-row {
  background-color: #EDF3F8 !important;
  border-top: 2px solid #0A4A79;
}

.totales-cell {
  color: #0A4A79 !important;
  font-size: 0.95rem !important;
}

.tabla-estadistica >>> thead th {
  background-color: #F8FAFC !important;
  color: #0A4A79 !important;
  font-weight: 700 !important;
  font-size: 0.9rem !important;
}

.tabla-estadistica >>> tbody tr:hover {
  background-color: #F8FAFC !important;
}
</style>
